import { useMenuItems } from '../../orderSlice';

export function MenuItemName({ id }: { id?: number }) {
  const menuItems = useMenuItems();
  const menuItem = menuItems.find((x) => x.id === id);
  return <>{menuItem ? menuItem.name : ''}</>;
}
